import { useMemo } from 'react';

import { HUBSPOT_SELECTION_MODAL_ID } from '@/app/[locale]/business/_components/HubspotSelectionModal/index';
import { useHubspotFormsContext } from '@/app/[locale]/business/_contexts/HubspotFormsContext';
import type { LandingPageCardData } from '@/app/components/LandingPage/LandingPageCards/types';

export default function useBusinessGalleryCards() {
  const { setActiveModal } = useHubspotFormsContext();

  const cards: LandingPageCardData[] = useMemo(() => {
    return [
      {
        link: {
          target: '_blank',
          href: 'https://app.smartsheet.com/b/form/41a3a719a4784cfcbc24c0f6974ec04f',
          label: 'business_gallery_gift_card_action',
        },
        description: 'business_gallery_gift_card_description',
        id: 'business_gallery_gift_card',
        image: {
          localizedAlt: 'corp_gift_image_alt_text',
          src: 'business/gift-oreo',
        },
        title: 'business_gallery_gift_card_title',
      },
      {
        link: {
          dataCy: 'business-gallery-bulk-order-action-button',
          onClick: (event) => {
            event.preventDefault();
            setActiveModal(HUBSPOT_SELECTION_MODAL_ID);
          },
          href: '#',
          label: 'business_gallery_bulk_order_action',
        },
        description: 'business_gallery_bulk_order_description',
        id: 'business_gallery_bulk_order',
        image: {
          localizedAlt: 'oreo_lined_up_alt',
          src: 'business/lined-up-oreo',
        },
        title: 'business_gallery_bulk_order_title',
      },
    ];
  }, [setActiveModal]);

  return cards;
}
